import { memo } from 'react';
import { Col, Flex, Typography } from 'antd';
import { ReactComponent as LogoCompanyIcon } from '@Icons/additional/logo-company-default.svg';
import { ReactComponent as DeliveryBoxIcon } from '@Icons/additional/delivery-box.svg';
import { ReactComponent as CoinsIcon } from '@Icons/additional/coins.svg';
import { ReactComponent as LocationIcon } from '@Icons/additional/location.svg';
import { useAppSelector } from '@Hooks/index';
import { currentMaterialHeaderRequest } from '@Features/MaterialRequest/requests/MaterialRequisition/store/selectors/materialRequestSelector';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

import RequestHeaderDetailsSection from './components/RequestHeaderDetailsSection';
import styles from './material-info.module.css';

const AVATAR_SIZE = 64;

interface MaterialRequestInformationProps {
  requestHeaderStep?: boolean;
}

const MaterialRequestInformation: React.FC<MaterialRequestInformationProps> = ({
  requestHeaderStep = true,
}) => {
  const { companyName, costCenter, costCenterType, mrFor } = useAppSelector(
    currentMaterialHeaderRequest
  );
  if (requestHeaderStep) {
    return <RequestHeaderDetailsSection />;
  }
  return (
    <>
      <Col span={24}>
        <Flex className={styles.userInfo}>
          <div>
            <LogoCompanyIcon />
          </div>
          <Flex
            vertical
            className={styles.userDesc}
            style={{ maxWidth: `calc(100% - ${AVATAR_SIZE}px)` }}
            justify="center"
          >
            <Typography.Text strong ellipsis>
              Company Name
            </Typography.Text>
            <Typography.Text>
              {companyName || EMPTY_FIELD_PLACEHOLDER}
            </Typography.Text>
          </Flex>
        </Flex>
        <div className={styles.userInfoDivider} />
      </Col>
      <Col span={24}>
        <Flex vertical className={styles.userBasicInfo}>
          <Typography.Text className={styles.userBasicInfoCaption} strong>
            Request Information
          </Typography.Text>
          <Flex gap={20} className={styles.userBasicInfoItem}>
            <div>
              <DeliveryBoxIcon />
            </div>
            <Flex vertical>
              <Typography.Text type="secondary">MR For</Typography.Text>
              <Typography.Text strong>
                {mrFor || EMPTY_FIELD_PLACEHOLDER}
              </Typography.Text>
            </Flex>
          </Flex>

          <Flex gap={20} className={styles.userBasicInfoItem}>
            <div>
              <CoinsIcon />
            </div>
            <Flex vertical>
              <Typography.Text type="secondary">
                Cost Center Type
              </Typography.Text>
              <Typography.Text strong>
                {costCenterType || EMPTY_FIELD_PLACEHOLDER}
              </Typography.Text>
            </Flex>
          </Flex>

          <Flex gap={20} className={styles.userBasicInfoItem}>
            <div>
              <LocationIcon />
            </div>
            <Flex vertical>
              <Typography.Text type="secondary">Cost Center</Typography.Text>
              <Typography.Text strong>
                {costCenter || EMPTY_FIELD_PLACEHOLDER}
              </Typography.Text>
            </Flex>
          </Flex>
        </Flex>
      </Col>
    </>
  );
};

export default memo(MaterialRequestInformation);
